/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'warning': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M38.179 33.754L25.801 12.801a1.5 1.5 0 0 0-2.602 0L10.821 33.754A1.498 1.498 0 0 0 12.123 36h24.754c.535 0 1.03-.285 1.299-.748a1.503 1.503 0 0 0 .003-1.498zM14.711 33L24.5 16.203 34.289 33H14.711zM26 29.375v2.25a.375.375 0 0 1-.375.375h-2.25a.375.375 0 0 1-.375-.375v-2.25c0-.207.168-.375.375-.375h2.25c.207 0 .375.168.375.375zM23.499 21h2.002c.274 0 .499.225.499.499v1.876c0 .207-.033.541-.073.742l-.675 3.453c-.04.201-.242.43-.449.43h-.588c-.207 0-.409-.229-.45-.43l-.69-3.422a4.752 4.752 0 0 1-.075-.773v-1.876c0-.274.225-.499.499-.499z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/warning.js